import { useTrans } from 'common-react';
import React, { FunctionComponent } from 'react';
import { Typography, ModalDialog } from 'ui-components';
import { useTranslation } from 'react-i18next';

const PotentialProfitInfoDialog: FunctionComponent<{
  open: boolean,
  onClose: () => void
}> = ({ open, onClose }) => {

  const { trans } = useTrans('select-recommended-funds');
  const { t } = useTranslation('select-recommended-funds');
  return (
    <ModalDialog
      open={open}
      onClose={onClose}
      title={t('potential-profit-modal-header')}
      content={<Typography variant="body1">{trans('potential-profit-modal-content')}</Typography>}
    />
  );
};

export default PotentialProfitInfoDialog;
